import { render, staticRenderFns } from "./SaveQuery.vue?vue&type=template&id=c3c3b9fe&scoped=true&"
import script from "./SaveQuery.vue?vue&type=script&lang=js&"
export * from "./SaveQuery.vue?vue&type=script&lang=js&"
import style0 from "./SaveQuery.vue?vue&type=style&index=0&id=c3c3b9fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3c3b9fe",
  null
  
)

export default component.exports